import { api } from "../api";

/**
 * findAllInterestPointsByCustomerIdCrudResponse - Function that finds on database all interest points by department and status as crud response data
 * /interest-points/{userId}/{customerId}/{status}
 * method GET
 * @async-function
 */
const findAllInterestPointsByCustomerIdCrudResponse = async (
    token: string,
    userId: number,
    customerId: number,
    status: string,
    page: number,
    size: number
) => {
    const response = await api.get(
        `/interest-points/${userId}/${customerId}/${status}?page=${page}&size=${size}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default findAllInterestPointsByCustomerIdCrudResponse;
